export default "/images/cover3.jpg?5d180a8cf437f491b09893cd0a866421";